export default __webpack_public_path__ + "assets/images/d49f099cb9db75942dadf66b143594b9.jpg";